export enum DoorvraagType {
  Slider = "SLIDER",
  TextArea = "TEXTAREA"
}
